import { fetchData, consoleDev, ConsoleStatus } from '@quizzach/utils';

export const usePremadeFeedback = () => {
	const sendPremadeFeedback = async ({
		premade_uuid,
		quality,
		level,
	}: {
		premade_uuid: string;
		quality: number | null;
		level: number | null;
	}) => {
		try {
			const response = await fetchData<any>(
				`/api/feedback`,
				{
					method: 'POST',
					body: JSON.stringify({
						level: level,
						premade_quality: quality,
						premade_quiz_uuid: premade_uuid,
					}),
				},
				{
					authRoute: true,
				}
			);
			if (response.status >= 300) {
				console.error('Failed to send premade feedback:', response.status);
				return false;
			}
			consoleDev('feedback', ConsoleStatus.SUCC);
			return true;
		} catch (err) {
			console.error('Failed to send premade feedback:', err);
			return false;
		}
	};

	return {
		sendPremadeFeedback,
	};
};
